import {useReducer} from "react";

const reducer = (value: number) => value + 1;
const initialState = 0;

export const useForceRender = () => {
  return useReducer(reducer, initialState);
};